module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/my_answer.e0b83.png";